import type { Theme } from '../../types/theme';

export const expoTheme: Theme = {
  id: 'expo',
  name: 'Expo',
  description: 'Dark theme with tight letter-spacing for React Native platform',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/expo/DESIGN.md',
  visualKeywords: ['dark', 'purple accent', 'tight letter-spacing', 'React Native', 'developer'],
  colors: {
    background: '#0a0a0a',
    surface: '#141414',
    surfaceElevated: '#1e1e1e',
    textPrimary: '#ffffff',
    textSecondary: '#a0a0a0',
    textMuted: '#a0a0a0',
    border: '#2a2a2a',
    borderSubtle: '#343434',
    primary: '#000020',
    primaryHover: '#0f0f2f',
    primaryActive: '#000002',
    accent: '#000020',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'high',
    tone: 'technical',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
